import { z } from 'zod';

const CentsSchema = z.string().regex(/^\d+$/);

export const ProductPricePolicyBandSchema = z.object({
  minCents: CentsSchema,
  maxCents: CentsSchema.nullable(),
  markupBp: z.number().int(),
});

export const SaveDefaultProductPricePolicyBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  bands: z.array(ProductPricePolicyBandSchema),
});

export const DefaultProductPricePolicyResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  currency: z.literal('BRL'),
  bands: z.array(ProductPricePolicyBandSchema),
});

export const SaveDefaultProductPricePolicyResponseSchema = DefaultProductPricePolicyResponseSchema;
export const GetDefaultProductPricePolicyResponseSchema = DefaultProductPricePolicyResponseSchema;

export type ProductPricePolicyBand = z.infer<typeof ProductPricePolicyBandSchema>;
export type SaveDefaultProductPricePolicyBody = z.infer<
  typeof SaveDefaultProductPricePolicyBodySchema
>;
export type SaveDefaultProductPricePolicyResponse = z.infer<
  typeof SaveDefaultProductPricePolicyResponseSchema
>;
export type GetDefaultProductPricePolicyResponse = z.infer<
  typeof GetDefaultProductPricePolicyResponseSchema
>;
